import { RequestStatus } from '$views/UserArea/UserArea.model'
import * as dayjs from 'dayjs'
import { mapCaretakerQualification } from '../../nursingHome.mapper'
import { AccompanimentsSearchService, AccompanimentsSearchServiceDto } from './accompanimentsSearch.model'

const mapCaretakers = (
  requestDto: AccompanimentsSearchServiceDto['relevantRequests'][0],
): AccompanimentsSearchService['caretakers'][0] => {
  return {
    id: requestDto.caretakerId,
    userId: requestDto.caretakerUserId,
    requestId: requestDto.requestId,
    name: requestDto.caretakerName,
    image: requestDto.caretakerProfileImage,
    qualification: mapCaretakerQualification(requestDto.mainQualification),
    accepted: requestDto.requestStatus === RequestStatus.requestAccepted,
    hourlyWage: requestDto.caretakerHourlyRate / 100,
    totalWage: requestDto.budget / 100,
  }
}

const mapServiceDate = (
  date: AccompanimentsSearchServiceDto['serviceSchedule'][0],
): AccompanimentsSearchService['dates'][0] => {
  return {
    startTime: dayjs(date.start).toDate(),
    endTime: dayjs(date.end).toDate(),
  }
}

export const mapAccompanimentsSearchServiceList = (
  serviceListDto: AccompanimentsSearchServiceDto[],
): AccompanimentsSearchService[] => {
  return serviceListDto.map((serviceDto: AccompanimentsSearchServiceDto) => ({
    serviceRef: serviceDto.serviceId,
    isRecommendation: serviceDto.serviceType === 'RECOMMENDATION',
    caretakers: serviceDto.relevantRequests.map(request => mapCaretakers(request)),
    caredPerson: serviceDto.resident,
    job: serviceDto.additionalInfo,
    dates: serviceDto.serviceSchedule.map(serviceDate => mapServiceDate(serviceDate)),
    duration: serviceDto.estimatedDuration,
    address: serviceDto.location,
    handler: serviceDto.requestedByInstitutionManager,
    numberOfAvailableCaretakers: serviceDto.numberOfAvailableCaretakers,
  }))
}



// WEBPACK FOOTER //
// ./src/domain/model/nursingHome/accompaniments/accompanimentsSearch/accompanimentsSearch.mapper.ts